var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnitMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00501 9C7.66778 9 9 7.66 9 6C9 4.34 7.66778 3 6.00501 3C4.34224 3 3 4.34 3 6C3 7.66 4.34224 9 6.00501 9Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9999 9.85718C4.00279 9.85718 0 10.86 0 12.8571V14.9999H11.9998V12.8571C11.9998 10.86 7.997 9.85718 5.9999 9.85718Z",
    fill: "#82AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8236 0H13.0589C13.6471 0 14.1177 0.470588 14.1177 0.941177V10L12.1177 8H5.05885C4.47062 8 4.00003 7.52941 4.00003 6.94118V3.17647V1C4.00003 0.447716 4.44774 0 5.00003 0H10.8236ZM10.0005 6H12.1177V5.17647H10.0005V6ZM6.00003 4.47059H12.1177V3.64706H6.00003V4.47059ZM6.00003 3.05882H12.1177V2.11765H6.00003V3.05882Z",
    fill: "#82AA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitMessages);
export default __webpack_public_path__ + "static/media/unit-messages.c31e9c0836d1d31e8de667b16e9d5fc5.svg";
export { ForwardRef as ReactComponent };